import kebabCase from 'lodash/kebabCase';
import toString from 'lodash/toString';
// Import Actions
import {
    PHOTOGRAPHER_SET_SUBAREAS,
PHOTOGRAPHER_SET_FILTERS,
PHOTOGRAPHER_SET_PAGE_FILTERS,
PHOTOGRAPHER_SET_APPLIED_FILTERS,
PHOTOGRAPHER_SET_PAGETAGS,
PHOTOGRAPHER_FETCHING_VENUES,
PHOTOGRAPHER_GET_VENUES,
PHOTOGRAPHER_FETCH_REVIEWS_FOR_PAGE,
PHOTOGRAPHER_FETCH_REVIEW_SUCCESS,
PHOTOGRAPHER_SET_VENUE_FILTER,
PHOTOGRAPHER_SET_VENUE_FILTER_ITEM,
PHOTOGRAPHER_RESET_FILTERS,
PHOTOGRAPHER_SET_VENUES,
PHOTOGRAPHER_SET_CITY,
PHOTOGRAPHER_SET_SORT_FILTERS,
PHOTOGRAPHER_SHORTLISTING_VENUE_FROM_LIST,
PHOTOGRAPHER_EVENT_MADE_STATE,
PHOTOGRAPHER_SET_SELECTED_VENUE,
PHOTOGRAPHER_UPDATING_VENUE_SEARCH_VALIDATORS,
PHOTOGRAPHER_UPDATE_VENUE_SEARCH_VALIDATORS,
PHOTOGRAPHER_FETCHING_SEARCHLINKS,
PHOTOGRAPHER_LOAD_SEARCHLINK,
PHOTOGRAPHER_SET_ACTIVE_LINK_FILTERS,
PHOTOGRAPHER_UPDATE_LODE_MORE_VENUES,
PHOTOGRAPHER_FETCHING_VENUE_DATA_FOR_COMPARE_PAGE,
PHOTOGRAPHER_FETCH_VENUE_DATA_FOR_COMPARE_PAGE,
PHOTOGRAPHER_FETCHING_COMPARE_VENUES,
PHOTOGRAPHER_CLEAR_COMPARE_VENUE_DATA,
PHOTOGRAPHER_IS_UPLOADING_MEDIA,
PHOTOGRAPHER_IS_OPEN_GALLERY_FOR_SEARCHPAGE,
PHOTOGRAPHER_CLICKED_VENUE_SEARCH_PAGE,
PHOTOGRAPHER_FETCH_VENUE_SEARCH_PAGE_ALL_ASSET,
PHOTOGRAPHER_SET_MIN_MAX_FILTER_ITEM,

} from '../actions/PhotographerAction';

// Initial State
const initialState = {
    pagetags: {},
    isBaseFiltersLoaded: false,
    isLocationFiltersLoaded: false,
    photographerSearchFilters: [],
    sortFilters: [],
    photographerSearchParams: [],
    appliedFilters: {},
    isFetchingVenues: false,
    list: [],
    city: '',
    totalCount: 0,
    pageNum: 1,
    pageSize: 30,
    isLoadingVenuePage: false,
    isLoadingVenueData: false,
    venue: {},
    mainPageVenue: {},
    packagePageVenue: {},
    assetPageVenue: {},
    reviewPageVenue: {},
    packages: [],
    images: [],
    menus: [],
    realevents: [],
    review: {},
    comments: [],
    commentMap: {},
    reviewPageNum: 1,
    totalCommentsCount: 0,
    userHasCommented: false,
    userComment: {},
    isLoadingUserReviewsPage: true,
    isPostingUserComment: false,
    isEditingUserComment: false,
    isUpdatingUserComment: false,
    isDeletingUserComment: false,
    isFetchingUserReviews: false,
    isFetchingComments: false,
    userReviews: [],
    userReviewCount: 0,
    currentUserReviewPage: 1,
    reportedComment: {},
    isFetchingReportedComment: false,
    isReportingComment: false,
    selectedVenue: {},
    recoVenues: [],
    isEventMade: false,
    isFetchingSimilarVenues: false,
    similarVenues: [],
    isFetchingPopularVenues: false,
    popularVenues: [],
    isFetchingCompareVenues: false,
    compareVenues: [],
    similarSubAreas: {},
    isFetchingSearchLink: false,
    isUpdatingVenueSearchValidators: false,
    searchlink: {},
    activeLinkFilters: {
        occasions: '',
        venuetypes: '',
        localities: '',
    },
    venueFormFilters: {},
    searchValidators: {},
    isReviewModalVisible: false,
    isReviewSuccessModalVisible: false,
    isReviewListModalVisible: false,
    isSavingUserProfileComment: false,
    isShortlistingVenue: false,
    venueExpertReview: {},
    venueQas: [],
    venueFaqs: [{
        _id: 1,
        question: 'What is the naem ?',
        answer: "My name is bhavya"
    }],
    venueSpaces: [],
    venueExpert: {},
    compareVenue: {},
    sublinkPageData: {},
    questionAlreadyExistVisiblity: false,
    totalReviewCount: 0,
    clickedVenueAssets: {},
    clickedPhotographer: {},
    isOpenGalleryForSearchPage: false,
    updateQnaPage: false,
    isFetchingVenueAssets: false,
};

const PhotographerReducers = (state = initialState, action) => {
    let clickedVenueAssets = {};
    switch (action.type) {

        case PHOTOGRAPHER_UPDATE_LODE_MORE_VENUES: //needed
            let prevVenues = state.list;
            let newVenueList = [];
            if (action.newVenues && action.newVenues.length > 0) {
                newVenueList = prevVenues.concat(action.newVenues);

                return {
                    ...state,
                    list: newVenueList,
                    pageNum: action.pageNum,
                    totalCount: action.totalCount,
                };

            } else {
                newVenueList = prevVenues;
                return {
                    ...state,
                    list: newVenueList,
                    pageNum: state.pageNum,
                    totalCount: state.totalCount,
                };
            }


        case PHOTOGRAPHER_SET_ACTIVE_LINK_FILTERS: //needed
            return {
                ...state,
                activeLinkFilters: action.activeLinkFilters,
            };



        case PHOTOGRAPHER_SET_PAGETAGS: //needed
            return {
                ...state,
                pagetags: action.pagetags,
            };

        case PHOTOGRAPHER_SET_VENUE_FILTER_ITEM: //needed
            let venueFilters = state.photographerSearchFilters.map(filterItem => {
                if (filterItem.queryParamName === action.paramName) {
                    filterItem.params = filterItem.params.map(item => {
                        item.isSelected = (kebabCase(item.value) === kebabCase(action.value));
                        return item;
                    });
                }
                return filterItem;
            });
            return {
                ...state,
                photographerSearchFilters: venueFilters,
            };

        case PHOTOGRAPHER_SET_MIN_MAX_FILTER_ITEM: //needed
        let vendorMinMaxFilter = [...state.photographerSearchFilters].map(filterItem => {
            if (filterItem.minQueryParamName === action.paramName) {
                filterItem.minParams = filterItem?.minParams?.map(item => {
                    item.isSelected = (toString(item.value) === toString(action.value));
                    return item;
                });
            } else if (filterItem.maxQueryParamName === action.paramName) {
                filterItem.maxParams = filterItem?.maxParams?.map(item => {
                        item.isSelected = (toString(item.value) === toString(action.value));
                        return item;
                    });
                }
                return filterItem;
            });
            return {
                ...state,
                photographerSearchFilters: vendorMinMaxFilter,
            };

        case PHOTOGRAPHER_SET_VENUE_FILTER: //needed
            let filters = state.photographerSearchFilters.map(filterItem => {
                if (filterItem.queryParamName === action.paramName) {
                    filterItem.params = filterItem.params.map(item => {
                        if (toString(item.value) === toString(action.value)) {
                            item.isSelected = action.isSelected;
                        }
                        return item;
                    });
                }
                return filterItem;
            });
            return {
                ...state,
                photographerSearchFilters: filters,
            };

        case PHOTOGRAPHER_FETCHING_VENUES: //needed
            return {
                ...state,
                isFetchingVenues: action.isFetchingVenues,
            };

        case PHOTOGRAPHER_GET_VENUES: //needed
            return {
                ...state,
                list: action.list,
                totalCount: action.totalCount,
                isFetchingVenues: action.isFetchingVenues,
                pageNum: action.pageNum,
                searchlink: action.searchlink,
                searchValidators: action.searchValidators,
            };

        case PHOTOGRAPHER_UPDATING_VENUE_SEARCH_VALIDATORS: //needed
            return {
                ...state,
                isUpdatingVenueSearchValidators: action.isUpdatingVenueSearchValidators,
            };

        case PHOTOGRAPHER_UPDATE_VENUE_SEARCH_VALIDATORS: //needed
            return {
                ...state,
                isUpdatingVenueSearchValidators: action.isUpdatingVenueSearchValidators,
                searchValidators: action.searchValidators,
                totalCount: action.totalCount,
            };

        case PHOTOGRAPHER_SHORTLISTING_VENUE_FROM_LIST: //needed
            let newList = state.list.map(item => {
                if (item._id === action.venueid) {
                    item.isShortlisting = action.value;
                }
                return item;
            });
            return {
                ...state,
                list: newList,
                isShortlistingVenue: action.value,
                shortlistingVenueId: action.venueid
            };


        case PHOTOGRAPHER_SET_APPLIED_FILTERS: //needed
            return {
                ...state,
                appliedFilters: action.appliedFilters,
            };

        case PHOTOGRAPHER_SET_FILTERS: //needed
            return {
                ...state,
                photographerSearchFilters: action.photographerSearchFilters,
                sortFilters: action.sortFilters,
                isBaseFiltersLoaded: action.isBaseFiltersLoaded,
                photographerSearchParams: action.photographerSearchParams,
            };

        case PHOTOGRAPHER_SET_PAGE_FILTERS: //needed
            return {
                ...state,
                photographerSearchFilters: action.photographerSearchFilters,
            };


        case PHOTOGRAPHER_FETCH_REVIEWS_FOR_PAGE: //needed
            return {
                ...state,
                isLoadingUserReviewsPage: action.isLoadingUserReviewsPage,
                isFetchingUserReviews: action.isFetchingUserReviews,
                currentUserReviewPage: action.currentUserReviewPage,
            };

        case PHOTOGRAPHER_FETCH_REVIEW_SUCCESS: //needed
            let userReviews = state.userReviews;
            if (action.userReviews && action.userReviews.length > 0) {
                userReviews = userReviews.concat(action.userReviews);
            } else {
                userReviews = [];
            }
            return {
                ...state,
                isLoadingUserReviewsPage: action.isLoadingUserReviewsPage,
                isFetchingUserReviews: action.isFetchingUserReviews,
                userReviews: userReviews,
                userReviewCount: action.userReviewCount,
            };


        case PHOTOGRAPHER_EVENT_MADE_STATE: //needed
            return {
                ...state,
                isEventMade: action.isEventMade,
            };

        case PHOTOGRAPHER_SET_SELECTED_VENUE: //needed
            return {
                ...state,
                selectedVenue: action.selectedVenue,
            };

        // case PHOTOGRAPHER_FETCHING_SEOLINKS: //needed
        //     return {
        //         ...state,
        //         isFetchingSeoLink: action.isFetchingSeoLink,
        //     };

        // case PHOTOGRAPHER_LOAD_SEOLINK: //needed
        //     return {
        //         ...state,
        //         isFetchingSeoLink: action.isFetchingSeoLink,
        //         seolink: action.seolink,
        //         list: action.list,
        //         totalCount: action.totalCount,
        //         isFetchingVenues: action.isFetchingVenues,
        //         pageNum: action.pageNum,
        //         pageSize: action.pageSize,
        //         photographerSearchFilters: action.photographerSearchFilters,
        //         sortFilters: action.sortFilters,
        //         isBaseFiltersLoaded: action.isBaseFiltersLoaded,
        //         venueSearchParams: action.venueSearchParams,
        //     };

        case PHOTOGRAPHER_FETCHING_SEARCHLINKS: //needed
            return {
                ...state,
                isFetchingSearchLink: action.isFetchingSearchLink,
            };

        case PHOTOGRAPHER_SET_SORT_FILTERS: //needed
            return {
                ...state,
                sortFilters: action.sortFilters,
            };

        case PHOTOGRAPHER_LOAD_SEARCHLINK: //needed
            return {
                ...state,
                isFetchingSearchLink: action.isFetchingSearchLink,
                searchlink: action.searchlink,
                list: action.list,
                totalCount: action.totalCount,
                isFetchingVenues: action.isFetchingVenues,
                pageNum: action.pageNum,
                pageSize: action.pageSize,
                locationFilters: action.locationFilters,
                occasionFilters: action.occasionFilters,
                venuetypeFilters: action.venuetypeFilters,
                amenityFilters: action.amenityFilters,
                minBudgetFilters: action.minBudgetFilters,
                maxBudgetFilters: action.maxBudgetFilters,
                minGuestFilters: action.minGuestFilters,
                maxGuestFilters: action.maxGuestFilters,
                regionFilters: action.regionFilters,
                packagetypeFilters: action.packagetypeFilters,
                sortFilters: action.sortFilters,
            };


        case PHOTOGRAPHER_FETCHING_COMPARE_VENUES: //needed
            return {
                ...state,
                isFetchingCompareVenues: action.isFetchingCompareVenues,
            };

        // case PHOTOGRAPHER_FETCH_COMPARE_VENUES: //needed
        //     return {
        //         ...state,
        //         compareVenues: action.compareVenues,
        //         isFetchingCompareVenues: action.isFetchingCompareVenues,
        //     };

        case PHOTOGRAPHER_FETCHING_VENUE_DATA_FOR_COMPARE_PAGE: //needed
            return {
                ...state,
                isLoadingVenueData: action.isLoadingVenueData,
            };

        // case FETCH_VENUE_DATA_FOR_COMPARE_PAGE: //needed
        //     let compareVenue = state.compareVenue;
        //     compareVenue = {...state.compareVenue, ...action.compareVenue};
        //     return {
        //         ...state,
        //         compareVenue: compareVenue
        //     };
        case PHOTOGRAPHER_CLEAR_COMPARE_VENUE_DATA: //needed
            let EmpytyCompareVenue = state.compareVenue;
            EmpytyCompareVenue = {};
            return {
                ...state,
                compareVenue: EmpytyCompareVenue
            };


        case PHOTOGRAPHER_IS_OPEN_GALLERY_FOR_SEARCHPAGE: //needed
            clickedVenueAssets = {...state.clickedVenueAssets};
            if (action.photographer && action.photographer._id) {
                if (clickedVenueAssets[action.photographer._id] ) {
                    clickedVenueAssets[action.photographer._id].photographer = action.photographer;
                } else {
                    clickedVenueAssets[action.photographer._id] = {};
                    clickedVenueAssets[action.photographer._id].photographer = action.photographer;
                }
            }
            return {
                ...state,
                isVenueGalleryOpen: action.isVenueGalleryOpen,
                isFetchingVenueAssets: action.isFetchingVenueAssets,
                clickedVenueAssets: clickedVenueAssets,
                clickedPhotographer: action.photographer
            }

        case PHOTOGRAPHER_CLICKED_VENUE_SEARCH_PAGE: //needed
            return {
                ...state,
                clickedVenueSearchPage: action.payload
            }

        case PHOTOGRAPHER_FETCH_VENUE_SEARCH_PAGE_ALL_ASSET: //needed
            clickedVenueAssets = {...state.clickedVenueAssets};
            if (action.photographer_id) {
                if (clickedVenueAssets[action.photographer_id] ) {
                    clickedVenueAssets[action.photographer_id].images = action.images;
                    clickedVenueAssets[action.photographer_id].assets = action.assets;
                } else {
                    clickedVenueAssets[action.photographer_id] = {};
                    clickedVenueAssets[action.photographer_id].images = action.images;
                    clickedVenueAssets[action.photographer_id].assets = action.assets;
                }
            }
            return {
                ...state,
                isFetchingVenueAssets: false,
                clickedVenueAssets: clickedVenueAssets,
            }

        default:
            return state;
    }
};

export const getVenuePage = state => state.venue.venue;

// Export Reducer
export default PhotographerReducers;
